import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as artifactActions from '~/artifact/actions';
import LoaderWrapper from '~/components/LoaderWrapper';
type ArtifactViewMainContentVulnerableMethodsComponentVersionsProps = {
  actions: object;
  artifactState: object;
};
class ArtifactViewMainContentVulnerableMethodsComponentVersions extends React.Component<
  ArtifactViewMainContentVulnerableMethodsComponentVersionsProps,
  {}
> {
  componentDidMount() {
    let store = this.props.artifactState,
      vulnerableVersionsByComponent = store.vulnerableVersionsByComponent,
      activeComponentId = store.componentId,
      vulnerableVersions = vulnerableVersionsByComponent[activeComponentId] || [],
      vulnerableVersion =
        vulnerableVersions && vulnerableVersions[0] ? vulnerableVersions[0].version : null;
    this.props.actions.updateComponentVersion(vulnerableVersion);
    if (!vulnerableVersions.length) {
      this.props.actions.fetchVulnerableComponentVersions(activeComponentId);
    }
  }
  updateActiveVulnerableVersion = e => {
    let version = e.target.value;
    this.props.actions.updateVulnerableVersion(version);
  };
  render() {
    const { artifactState } = this.props;
    const {
      vulnerableVersionsByComponent = {},
      componentId: activeComponentId,
      isFetchingVulnerableVersions = false,
      activeVulnerableVersion,
    } = artifactState;
    const { [activeComponentId]: activeVersions = [] } = vulnerableVersionsByComponent;
    const versionOptions = [];
    const self = this;
    activeVersions.forEach(function(version) {
      versionOptions.push(
        <div key={'version-' + version.version} className="grid__item col-1-1">
          <label className="label--radio">
            <input
              type="radio"
              name={version.version}
              value={version.version}
              checked={version.version === activeVulnerableVersion}
              onChange={self.updateActiveVulnerableVersion}
            />
            <span className="react--radio" /> {version.version}
          </label>
        </div>
      );
    });
    return (
      <div className="grid grid--full col-1-1">
        <div className="grid__item col-3-4">
          <div className="font--h6 mb-">Vulnerable versions</div>
        </div>

        <div className="grid__item col-1-1 mt-">
          <LoaderWrapper isLoaderShowing={isFetchingVulnerableVersions} loaderType="SPINNER">
            <form className="grid max-height--400">{versionOptions}</form>
          </LoaderWrapper>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentVulnerableMethodsComponentVersions);
